const baseURL = import.meta.env.VITE_BASE_URL;

export const hrLoginEndpoint = `${baseURL}/hr/login`;
export const hrGetBaseStatsEndpoint = (week) => `${baseURL}/hr/base_stats?week=${week}`;
export const hrGetSlotsForDashboardEndpoint = (day, week) => `${baseURL}/hr/slots/${day}?week=${week}`;
export const hrListGetAssignableCustomerEndpoint = (id) => `${baseURL}/hr/customer/list/${id}/assignable`
export const hrCustomerAssignToSlotEndpoint = (customerID, listID, slotID, oldCustomerID) => `${baseURL}/hr/customer/${customerID}/list/${listID}/assign/${slotID}?old_customer_id=${oldCustomerID}`;
export const hrCancelSlotEndpoint = (id) => `${baseURL}/hr/contract/slot/${id}/cancel`;
export const hrSettingsBaseEndpoint = `${baseURL}/hr/settings/base`;
export const hrSettingsPasswordEndpoint = `${baseURL}/hr/settings/password`;
export const hrEmployeeListEndpoint = `${baseURL}/hr/employee/list`;
export const hrCompanyWideLimitStatsEndpoint = `${baseURL}/hr/employee/company_wide_limit_stats`;
export const hrUpdateCompanyWideLimitEndpoint = (limitType, limit, contractTypeID) => `${baseURL}/hr/employee/company_wide_limit_stats/${limitType}/${limit}/${contractTypeID}`;
export const hrGetContractTypesEndpoint = `${baseURL}/hr/contract_types`;
export const hrUpdateEmployeeLimitEndpoint = (id) => `${baseURL}/hr/employee/limit/${id}`;
export const hrChangeEmployeeStateEndpoint = (id) => `${baseURL}/hr/employee/state/${id}`;
export const hrCreateEmployeeEndpoint = `${baseURL}/hr/employee`;
export const resetPasswordEndpoint = `${baseURL}/admin/reset_password`;

export const hrEmployeeReportEndpoint = (startDate, endDate) => `${baseURL}/hr/report/employee?start_date=${startDate}&end_date=${endDate}`;
export const hrGuestCustomerCreateEndpoint = (slotID) => `${baseURL}/hr/guest/create/${slotID}`;
export const hrFeedbackEndpoint = `${baseURL}/hr/feedback`;
export const hrGetWeekStatsEndpoint = `${baseURL}/hr/weeks_with_active_lists`;
export const hrInfoLocatieRezervariEndpoint = `${baseURL}/hr/info_locatie_rezervari`;


export const hrGetWaitingListAmountEndpoint = (listID) => `${baseURL}/hr/waiting_list/${listID}/amount`;
export const hrGetWaitingListDetailsEndpoint = (listID) => `${baseURL}/hr/waiting_list/${listID}/details`;
export const hrRegisterWaitingListEndpoint = (listID) => `${baseURL}/hr/waiting_list/${listID}/register`;
export const hrRemoveWaitingListEndpoint = (listID) => `${baseURL}/hr/waiting_list/${listID}/remove`;
